<template>
    <b-row>
        <b-col cols="12" md="6">
            <div class="box mr-2">
                <h3>{{ $t('fdb.dashboard.hello') }},</h3>
                <p>{{ $t('fdb.dashboard.overview_message') }}</p>
                <b-row class="mt-auto">
                    <b-col cols="12" md="6">
                        <div class="subbox">
                            <b-row align-v="center">
                                <b-col cols="8">
                                    <b> {{ $t('fdb.dashboard.drivers') }}</b>
                                </b-col>
                                <b-col cols="4" class="d-flex flex-column">
                                    <div class="font-size-xs">{{ $t('fdb.dashboard.active') }}</div>
                                    <div class="display-3 mb-0">{{ driversCount }}</div>
                                </b-col>
                            </b-row>
                        </div>
                        <div @click="$emit('setTab', 1)" class="subbox-btn subbox-btn-add-driver">
                            <b>{{ $t('fdb.dashboard.add_driver') }}</b>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="subbox">
                            <b-row align-v="center">
                                <b-col cols="8">
                                    <b>{{ $t('fdb.dashboard.subscriptions') }}</b>
                                </b-col>
                                <b-col cols="4" class="d-flex flex-column">
                                    <div class="font-size-xs">{{ $t('fdb.dashboard.active') }}</div>
                                    <div class="display-3 mb-0">{{ subscriptionsCount }}</div>
                                </b-col>
                            </b-row>
                        </div>
                        <div @click="$emit('setTab', 2)" class="subbox-btn subbox-btn-show-all">
                            <b>{{ $t('fdb.dashboard.show_all') }}</b>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-col>
        <b-col cols="12" md="6">
            <div class="box ml-2">
                <h3>{{ $t('fdb.dashboard.your_personal_data') }}</h3>
                <p>{{ $t('fdb.dashboard.request_change_data') }}</p>
                <b-row class="mt-auto">
                    <b-col cols="12" md="6">
                        <div class="subbox">
                            <b>{{ $t('fdb.dashboard.invoice_address') }}</b><br>
                            <span class="mt-2 d-block">{{ coreUserInvoiceAddressCompany }}</span>
                            <span>{{ `${coreUserInvoiceAddressStreet} ${coreUserInvoiceAddressHouseNumber}` }}</span><br>
                            <span>{{ `${coreUserInvoiceAddressPostalCode} ${coreUserInvoiceAddressCity}` }}</span>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="subbox">
                            <b>{{ $t('fdb.dashboard.personal_data') }}</b><br>
                            <span class="mt-2 d-block"> {{ coreUserDetailsName }}</span>
                            <span>{{ coreUserDetails.email }}</span><br>
                            <span>{{ coreUserDetails.telephone }}</span>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-row>
</template>
<script>
import { BTab, BMedia, BImg, BRow, BCol } from 'bootstrap-vue'
import SpaceBreak from '../atoms/SpaceBreak.vue'

export default {
    name: "FdbTabDashboard",
    components: {
        BTab, BMedia, BImg, BRow, BCol,
        SpaceBreak
    },
    data() {
        return {
            driversCount: '',
            subscriptionsCount: '',
            address: [],
            selectedCompany: JSON.parse(localStorage.getItem('selectedCompany'))
        }
    },
    async created() {
        const response = await this.$axios.get(`api/v1/fleetmanager/count-drivers-subscriptions`)
        this.driversCount = response.data.drivers_count
        this.subscriptionsCount = response.data.subscriptions_count
    },
    mounted() {
        this.getCompanyAddress()
    },
    methods: {
        getCompanyAddress() {
            this.$axios.get('api/v1/fleetmanager/address')
            .then(response => {
                if (response) {
                    this.address = response.data.payload
                }
            }).catch(error => {
                console.error(error)
            })
        }
    },
    computed: {
        coreUserDetails() {
            return this.$root.user.state.data.core_user
        },
        coreUserInvoiceAddressCompany() {
            return this.selectedCompany.name ?? ''
        },
        coreUserInvoiceAddressStreet() {
            return this.address.street ?? ''
        },
        coreUserInvoiceAddressHouseNumber() {
            return this.address.house_number ?? ''
        },
        coreUserInvoiceAddressPostalCode() {
            return this.address.postal_code ?? ''
        },
        coreUserInvoiceAddressCity() {
            return this.address.city ?? ''
        },
        coreUserDetailsName() {
            return this.$root.user?.state?.data?.name ?? ''
        },
    }
}
</script>

<style lang="scss" scoped>
 .box {
     background: #F8F8F8;
     padding: 60px;
     height: 100%;
     display: flex;
     flex-direction: column;
     .subbox {
         background: #fff;
         padding: 39px;
         box-shadow: 0 5px 7px #ddd;
         margin-top: 36px;
         word-break: break-all;
     }
     .subbox-btn {
         padding: 14px 19px;
         color: #fff;
         cursor: pointer;
         &-add-driver {
             background: #C62929;
         }
         &-show-all {
            background: #36ACBB;
         }
     }
 }
</style>
